import moment from 'moment';
import 'moment/locale/es';

export const completar_String = (cadena, char_relleno, tam_final) => {
    let tam_actual = cadena.toString().length;    
    let veces_repetir = tam_final - tam_actual;
    return char_relleno.repeat(veces_repetir).concat(cadena);
}


export const formatearFecha = (fecha) => {
    if(fecha===null){
        return '';
    }
    
    if (fecha===''){
        return fecha;
    }

    var partes_fecha = '';
    var temp = '';
    partes_fecha = fecha.substring(0, 10).split("-");
    temp = partes_fecha[2];
    partes_fecha[2] = temp.substring(0, 2);
    fecha = partes_fecha[2] + '/' + partes_fecha[1] + '/' + partes_fecha[0];
    return fecha;
}

export const desformatearFecha = (fecha) => {
    var partes_fecha = '';
    partes_fecha = fecha.split("/");
    fecha = partes_fecha[2] + '-' + partes_fecha[1] + '-' + partes_fecha[0];
    return fecha;
}

export const formatearNumeroDecimal = (numero, numeroDecimales) =>{
    numero = parseFloat(numero);
    numeroDecimales = numeroDecimales || 2;
    if (isNaN(numero) || numero === 0){
        return parseFloat(0).toFixed(numeroDecimales);
    }
    numero = numero.toFixed(numeroDecimales);    
    
    let partes_numero = numero.split('.'), regexp = /(\d+)(\d{3})/;
    
    while (regexp.test(partes_numero[0])){        
        partes_numero[0] = partes_numero[0].replace(regexp, '$1,$2');
    }
    return partes_numero.join('.');
}

//Entra un numero formateado string y devuelve un float sin comas
export const desformatearNumeroDecimal = (numero) =>{
    var valorpart = [];
    var newVal = "";

    valorpart = numero.split(",");
    for(var i = 0; i< valorpart.length; i++){
        newVal = newVal+valorpart[i]
    }
    return parseFloat(newVal);
}

//Permite limpiar el resultado del control SelectgetAsync
export const formatearLabel = (label) => {
    var temp;
    temp = label.split("(");

    return temp[0];
}

export const formatearNumeroEntero = (valor) => {
    valor = parseInt(valor, 10);        
    return valor;
}

export const formatearFechaMoment_a_String = (fechaMoment) => {
    moment.locale('es');
    return moment(fechaMoment).format('L');
}

export const formatearFechaMoment_a_StringFormatoReporte = (fechaMoment) => {
    moment.locale('es');
    let fecha = moment(fechaMoment).format('L');    
    return fecha.substr(6, 4) + '-' + fecha.substr(3, 2) + '-' + fecha.substr(0, 2);
}